import styled from "styled-components";
import { useModal } from 'hooks/modalContext';

import CloseBtn from "../util/CloseModal";
import {useEffect, useState} from "react";
import * as Server from "../../assets/js/Server";
import useDidMountEffect from "../../assets/js/useDidMountEffect";
import * as Common from "../../assets/js/Common";


export default function SelectExcelRead(props) {
  const { closeModal } = useModal();

  const [result, setResult] = useState({
    custMstSeq: '',
    cpatureList: []
  })

  const [isSubmit, setIsSubmit] = useState(false);

  const [clientList, setClientList] = useState();

  //고객사 조회
  const getClientList = () => {
    Server.sendGet('client/select', {}, getClientListCallback).then();
  };

  const getClientListCallback = res => {
    setClientList(res['resultList']);
  };

  const sendExcelData = () => {
    if(!isSubmit) {
      setIsSubmit(true);

      Server.sendPost('client/excel', result, sendExcelDataCallback).then();
    }
  }

  const sendExcelDataCallback = res => {
    setIsSubmit(false);
    Common.alertSuccess();
    closeModal();

  }

  useEffect(() => {
    getClientList();

    setResult(() => {
      return {
        ...result,
        manualInfoList: props.props.cpatureList
      }
    })
  }, []);

  useDidMountEffect(() => {
    setResult(() => {
      return {
        ...result,
        manualInfoList: props.props.data.item
      }
    })

    console.log(result);
  }, [props])

  return (
    <>
      <CloseBtn onClick={closeModal} />

      <div className='modal-box'>
        <div className='inner'>
          <Title>
            <TitHead>
              <i/>
              <h4>Select Customer</h4>
            </TitHead>
          </Title>
          <div className='form-in'>
            <select
              onChange={e => {
                setResult(() => {
                  return {
                    ...result,
                    custMstSeq: e.target.value,
                  }
                })
              }}
            >
              <option value='default'>Please select a customer.</option>
              {clientList?.map((item, key) => (
                <>
                  <option value={item.custMstSeq}>{item.custName}</option>
                </>
              ))}
            </select>
          </div>

          <div className='edit-btn'>
            <button onClick={closeModal} className='cancel'>Cancel</button>
            <button
              className='submit'
              onClick={sendExcelData}
            >OK</button>
          </div>
        </div>
      </div>
    </>
  )
}

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;
